import { LitElement, html, css, unsafeHTML, nothing } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js'

/**
 * Skio Universal Plan Picker
 * @docs https://integrate.skio.com/
 *
 * Uses LitJS (<5kb) https://lit.dev/ for reactive web components
 */

export class SkioPlanPicker extends LitElement {
  static properties = {
    key: { type: String },

    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },

    options: { type: Object },

    moneyFormat: { type: String },

    quantity: { type: Number },
    rules: { type: Array },
    rule: { type: Object },
    cart: { type: Object },

    availableSellingPlanGroups: { state: true },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },

    pdpMode: { type: Boolean, reflect: true },
    miniMode: { type: Boolean, reflect: true },
    collectionMode: { type: Boolean, reflect: true },
    showSubscriptionToggle: { type: Boolean, reflect: true },
    futurePriceAdjustment: { type: String },

    disableUrl: { type: Boolean },
    debug: { type: Boolean },
  }

  static styles = [
    css`
      :host {
        width: 100%;
      }
      variant-radios {
       display: none;
      }
      .skio-plan-picker {
        display: flex;
        padding: 0;
        border: 0;
        font-size: 15px;
        color: black;
        width: 100%;
        font-family: inherit;
        max-width: 100%;
        margin: 0px;
      }

      :host([layout='hidden']) .skio-plan-picker {
        display: none;
      }

      :host([layout='vertical']) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout='horizontal']) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, transparent);
        color: var(--skio-group-text-color, #000);
      }

      .group-container--selected {
        border-color: #271D16;
        background-color: var(--skio-group-background-selected-color, transparent);
        color: var(--skio-group-text-selected-color, #000);
        border: var(--skio-group-border-width, 1px) solid var(--skio-group-border-color, #ccc);
      }

      .group-container--last {
        order: 1;
      }

      .group-container--hidden {
        display: none;
      }

      .group-container.group-container-onetime {
           border: 2px solid rgb(229, 224, 216);
           border-radius: 12px !important;
           background-color: #fff;
       }

       .group-container.group-container-onetime.group-container--selected {
        background-color: rgba(241, 217, 177, 0.25);
      }

      :host([layout='horizontal']) .group-container {
        width: calc(50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px)));
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

      .group-input:focus-visible ~ .group-label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 20px 20px 20px 20px;
        cursor: pointer;
      }

      .group-topline {
           display: flex;
           align-items: center;
           width: 100%;
           gap: 8px;
           justify-content: space-between;
        }

      .group-container--selected .group-topline {
        font-weight: 400;
      }

      :host([layout='horizontal']) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      .skio-radio__container {
        display: flex;
        color: #1f0a0069 !important;
      }

      .group-container--selected .skio-radio__container {
        color: var(--skio-group-border-selected-color, #333);
      }

      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 1;
        transform: scale(0.8);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(0.8);
        color: #000;
      }

     .skio-price-flex {
    display: flex;
    gap: 2px;
    flex-direction: column;
    font-size: 16px;
    font-weight: 500;
    color: #000;
}
      .skio-price {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: flex-end;
        text-align: right;
        padding-top: 8px;
        line-height: 1;
        margin-left: auto;
        vertical-align: middle;
        font-weight: 400;
        font-size: 16px;
        font-family: CeraPro-bold;
        color: #c14829;
        position: relative;
      }

      .group-container-sub .skio-price::after {
        content: "Free Shipping";
        text-transform: uppercase;
        color: #c14829;
        font-size: 12px;
        position: relative;
        top: 5px;
      }
      .group-container.group-container-sub.group-container--selected .skio-price::after {
         top: 20px;
      }
      .group-container.group-container-sub.group-container--selected select.selling-plan-dropdown, 
        .group-container.group-container-sub.group-container--selected .group-subtitle {
          display: flex;
      }
      .group-subtitle {
       flex-direction: column;
       gap: 12px;
      }
       .group-subtitle-group {
    display: flex;
    align-items: center;
    gap: 6px;
}
      select.selling-plan-dropdown, .group-subtitle {
           display: none;
       }

      .group-container-onetime .skio-price {
        color: #525252;
      }

      .skio-price s {
        color: #969491;
      }

      :host([layout='horizontal']) .skio-price {
        text-align: center;
        margin-right: auto;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: 100%;
        max-height: 1000px;
        transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

     .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: #000;
      }

      :host([layout='horizontal']) .group-content {
        width: 100%;
      }

      /* Hide frequency if not selected */
      /* .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      } */

      :host([layout='horizontal']) .group-container:not(.group-container--selected) + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .center-topline-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 70%;
        position: relative;
      }

      .group-title {
        line-height: 32px;
        font-weight: 500;
        font-size: 16px;
        color: rgb(31, 10, 0);
        display: inline;
        align-items: center;
        position: relative;
      }

      .group-subtitle {
        color: #000;
        font-size: 12px;
        font-family: var(--bs-body-font-family);
        font-weight: 400;
        padding-bottom: 10px;
        margin-left: 10px;
        padding-top: 15px;
        gap: 6px;
      }

      :host([layout='horizontal']) .group-title {
        max-width: 100%;
      }

     .savings {
        background: rgb(255, 201, 66);
        color: rgb(0, 0, 0);
        font-size: 16px;
        padding: 4px 12px;
        border-radius: 20px;
        text-transform: uppercase;
        line-height: normal;
        font-weight: 400;
         min-height: 20px;
         display: inline-flex;
         align-items: center;
       }
        .selling-plan-dropdown::focus-visible{
        outline: unset !important;
        box-shadow: unset !important;
        }

      .savings.bubble {
        padding: 0px 8px;
        background-color: var(--skio-discount-color, #0fa573);
        border: 1px var(--skio-discount-color, #0fa573) solid;
        border-radius: 4px;
        font-size: 12px;
        color: var(--skio-discount-text-color, #fff);

        white-space: nowrap;
      }

      .selling-plan-dropdown {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        background-color: transparent;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        background-size: 16px;
        border-radius: 7px;
        border: none;
        font-size: 13px;
        color: var(--skio-group-text-selected-color, #000);
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: CeraPro-medium;
        max-width: 300px;
        height: 30px;
        padding-left: 10px;
      }

      .selling-plan-dropdown-label {
        color: #666666;
        font-weight: 500;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--skio-button-plan-selector-width, 20px), 1fr));
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type='radio'] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type='radio']:checked + label {
        border-color: #000;
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .group-content-additional {
        margin-top: 5px;
      }

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: #000;
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: white;
        box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px) 10;
      }

      .setupMode:after {
        content: 'Setup Mode';
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }

      .skio-learn_more_pdp {
        max-width: fit-content;
        text-align: left;
        margin-top: 5px;
        margin-bottom: 18px;
      }

      .skio-custom-learn-more {
        color: #c14829;
        padding-right: 10px;
        text-decoration: underline;
        font-size: 16px;
        line-height: 21px;
        text-transform: capitalize;
        font-family: CeraPro-reg;
        font-weight: unset;
        cursor: pointer;
      }

      .group-title-sub-tooltip {
        position: absolute;
        bottom: 11px;
        display: inline-block;
        padding: 0;
        width: 14px;
        height: 14px;
        margin-left: 5px;
        background-size: cover;
        z-index: 100;
        background-image: url(data:image/webp;base64,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)
      }

      .group-title-sub-tooltip:hover::after {
        content: attr(data-tooltip);
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #c14829;
        color: white;
        padding: 12px;
        font-size: 12px;
        font-family: CeraPro-reg;
        border-radius: 10px;
        text-align: center;
        width: 190px;
        line-height: normal;
        z-index: 1;
        white-space: normal;
      }

      :host([miniMode]) .skio-plan-picker {
        flex-direction: row;
        justify-content: center;
        padding: 0 10px;
        flex-wrap: wrap;
        margin-bottom: 10px;
        row-gap: 0;
        max-width: fit-content;
        margin: auto;
      }
      :host([miniMode]) .group-content {
        order: 1;
        min-width: 100%;
        margin-left: 0;
        align-items: center;
      }
      :host([miniMode]) .group-container--selected,
      :host([miniMode]) .group-container {
        border: none;
      }
      :host([miniMode]) .group-container-sub {
        margin-right: 30px;
      }
      :host([miniMode]) .selling-plan-dropdown {
        background-color: #f0dcb6;
        color: #000;
      }
      :host([miniMode]) .group-title-sub-tooltip {
        right: -20px;
      }
      :host([miniMode]) .group-label {
        padding: 0;
      }
      :host([miniMode]) .group-topline {
        justify-content: flex-start;
      }
      :host([miniMode]) .group-title {
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        display: flex;
        max-width: unset;
        gap: 5px;
      }
      :host([miniMode]) .savings {
        display: flex;
      }
      :host([collectionMode]) .selling-plan-dropdown {
        font-family: CeraPro-bold;
      }
      .frother-image-text {
        display: flex;
        align-items: center;
        gap: 5px;
        font-family: CeraPro-reg;
        margin-left: 0;
        margin-right: 0;
      }
      .line_text {
        white-space: normal;
      }
      .line_text p, .free_first_time_2 .line_text {
        font-size: 12px;
        margin: 0;
      }
      .supplement_fact span, .free_first_time strong, .free_first_time_2 strong {
        color: #c14829;
      }
       
      .custom-subscription-card {
  border: 1px solid #e5e0d8;
  padding: 20px;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #ffffff;
  position: relative;
}
  fieldset.skio-plan-picker {
    border: 1px solid #D8DAE4 !important;
    border-radius: 12px;
}

.custom-subscription-card:hover {
  border-color: #b8a99a;
}

.custom-subscription-card.selected {
  background: #F1D9B140;
}
.custom-subscription-card:first-of-type {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.custom-subscription-card:last-of-type {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.plan-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.plan-price {
  font-weight: 700;
  font-size: 18px;
  color: #000;
  display: flex;
  gap: 8px;
  align-items: center;
}

.plan-price s {
  font-size: 14px;
  color: #9a8f86;
}

.plan-badge {
  background: #ffc942;
  color: #000;
  font-size: 16px;
  padding: 4px 12px;
  border-radius: 20px;
  text-transform: uppercase;
  line-height: normal;
  font-weight: 400;
}
  .plan-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.plan-title {
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1f0a00;
}

.plan-sub {
    color: #1F0A00;
    font-family: "Cera Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    padding-left: 32px;
    padding-top: 5px;
}
.custom-radio {
  width: 18px;
  height: 18px;
  border: 2px solid #1f0a0069;
  border-radius: 50%;
  position: relative;
}

.custom-radio.checked::after {
  content: '';
  width: 10px;
  height: 10px;
  background: #271D16;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.buy-once-wrapper {
    margin-bottom: 15px;
    text-align: center;
    margin-top: 20px;
    width: calc(100% + 2px);
}
.buy-recommend {
    color: #6A6A6A;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
     position: relative;
    top: 80px;
}
.buy-once-wrapper a {
color:  #C1472A;
text-align: center;
font-family: "Cera Pro";
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height:  19.6px;
text-decoration-line: underline;
  }
.freeshipping {
    color: #6A6A6A;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-left: 31px;
    padding-top: 5px;
}

@media (max-width: 749px) {
  .buy-once-wrapper {
    top: 105px;
    left: auto;
    }
    .buy-recommend {
    font-size: 12px;
    gap: 2px;
     top: 90px;
   }
  }


      @media (max-width: 550px) {

      .selling-plan-dropdown {
       width: fit-content;
       padding-left: 0;
      padding-right: 25px;
       }
       .group-title {
       font-size: 14px;
       }
       .group-label {
         padding: 20px 20px 20px 20px;
    
         }
         .plan-badge {
              padding: 4px 8px;
              font-size: 14px;
         }
      }
        @media (max-width: 400px) {
          .selling-plan-dropdown {
         width: 200px;
       }
        .savings.bubble {
        padding: 0px 4px;
        }
        .savings {
        font-size: 10px;
          }
        .buy-recommend {
          font-size: 10px;
        }
         }
    @media (max-width: 390px) {
         .plan-badge {
               padding: 4px 6px;
               font-size: 12px;
          }
        }
    `,
  ]

  constructor() {
    super()

    // Start - Debug Variables
    this.debug = this.debug || window?.Shopify?.designMode
    this.variantChanged = false
    // End - Debug Variables

    this.rules = []
    this.rule = null
    this.quantity = 1
    this.showDetailsHover = false
  }

  async connectedCallback() {
    super.connectedCallback()

    window.addEventListener('skio-subscription-toggle', this.handleSubscriptionToggle);
    if (this.collectionMode) {
      const key = 'skio-subscription-toggle';
      const handle = window.location.pathname.split('/').pop();

      const saved = JSON.parse(localStorage.getItem(key) || '{}');
      const savedState = saved[handle];

      const isToggleOn =
      typeof savedState === 'boolean'
        ? savedState
        : document.getElementById('boost-collections-subscription-toggle')?.checked ?? false;
  
      window.dispatchEvent(new CustomEvent('skio-subscription-toggle', {
        detail: { show_subscriptions: isToggleOn },
      }));
    } else {
      // On product pages or anywhere else, just default to true
      this.showSubscriptionToggle = true;
    }
  
    this.log('Mounted')

    if (this.productHandle) {
      this.loading = true
      this.fetchProduct(this.productHandle)
    }

    this.bindFormEvents()
    this.bindCartEvents()

    this.rules = await this.fetchRules()
    await this.getRule()

    // update price on initial load
    requestAnimationFrame(() => {
        this.updateCurrentDisplayedPrice();
     });

  }

  // SECTION: Element Templates
  radioTemplate() {
    return html`
      <div class="skio-radio__container">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#ffffff80" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"></circle>
          <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
        </svg>
      </div>
    `
  }

  getVariantForPlan(planId) {
  // ✅ FIRST: use currently selected variant if valid
  const selectedVariant = this.selectedVariant;

  if (
    selectedVariant?.selling_plan_allocations?.some(
      allocation =>
        String(allocation.selling_plan_id) === String(planId)
    )
  ) {
    return selectedVariant;
  }

  // ✅ fallback
  for (const variant of this.product.variants) {
    for (const allocation of variant.selling_plan_allocations || []) {
      if (String(allocation.selling_plan_id) === String(planId)) {
        return variant;
      }
    }
  }

  return null;
}

getPlanPrice(plan) {
  const variant = this.getVariantForPlan(plan.id);
  if (!variant) return '';

  const oneTimePrice = variant.price; // base price
  const adjustment = plan.price_adjustments?.[0];

  let subscriptionPrice = oneTimePrice;

  if (adjustment) {
    switch (adjustment.value_type) {
      case 'percentage':
        subscriptionPrice = oneTimePrice - (oneTimePrice * adjustment.value / 100);
        break;

      case 'fixed_amount':
        subscriptionPrice = oneTimePrice - adjustment.value;
        break;

      case 'price':
        subscriptionPrice = adjustment.value;
        break;
    }
  }

  const showCompare = subscriptionPrice < oneTimePrice;

  return html`
    <div class="skio-price-flex">
      ${this.money(subscriptionPrice)}
      ${showCompare
        ? html`<s>${this.money(oneTimePrice)}</s>`
        : ''}
    </div>
  `;
}

updateMainPrice(price) {

  const formattedPrice = this.money(price);

  requestAnimationFrame(() => {

    const priceElements = document.querySelectorAll(
      '.price-item--regular'
    );

    priceElements.forEach(el => {
      el.innerHTML = formattedPrice;
    });
  });
}

updateCurrentDisplayedPrice() {

  // one-time
  if (!this.selectedSellingPlan) {

    this.updateMainPrice(
      this.selectedVariant.price
    );

    return;
  }

  // subscription
  const adjustment =
    this.selectedSellingPlan.price_adjustments?.[0];

  let subscriptionPrice =
    this.selectedVariant.price;

  if (adjustment) {

    switch (adjustment.value_type) {

      case 'percentage':
        subscriptionPrice =
          this.selectedVariant.price -
          (
            this.selectedVariant.price *
            adjustment.value / 100
          );
        break;

      case 'fixed_amount':
        subscriptionPrice =
          this.selectedVariant.price -
          adjustment.value;
        break;

      case 'price':
        subscriptionPrice =
          adjustment.value;
        break;
    }
  }

  this.updateMainPrice(subscriptionPrice);
}

formatPlanContent(plan) {
  if (!plan?.name) {
    return {
      title: '',
      subtitle: ''
    };
  }

  // 🔥 Split by first hyphen
  const parts = plan.name.split(' - ');

  const title = parts[0]?.trim() || plan.name;
  const subtitle = parts[1]?.trim() || '';

  return {
    title,
    subtitle
  };
}

getFirstPlanForVariant(group) {
  const plans = this.getAvailableSellingPlans(group);
  const variantPlans = this.selectedVariant?.selling_plan_allocations || [];

  for (const allocation of variantPlans) {
    const match = plans.find(
      p => String(p.id) === String(allocation.selling_plan_id)
    );
    if (match) return match;
  }

  return plans[0]; // fallback
}

getPlansInVariantOrder(group) {
  const plans = this.getAvailableSellingPlans(group);
  const variants = this.product?.variants || [];

  // create plan order map based on variant order
  const orderedPlanIds = [];

  variants.forEach(variant => {
    (variant.selling_plan_allocations || []).forEach(allocation => {
      const id = String(allocation.selling_plan_id);

      if (!orderedPlanIds.includes(id)) {
        orderedPlanIds.push(id);
      }
    });
  });

  // sort plans according to variant order
  return plans.slice().sort((a, b) => {
    return (
      orderedPlanIds.indexOf(String(a.id)) -
      orderedPlanIds.indexOf(String(b.id))
    );
  });
}

  sellingPlanDropdown(group) {
    return html`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(group).length == 1 ? 'selling-plan-dropdown--one' : ''}"
        @change=${e => {
          this.selectSellingPlan(e.target.value)
        }}
      >
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html` <option ?selected=${group.selected_selling_plan.id === selling_plan.id} value=${selling_plan.id}>${this.sellingPlanDropdownOptionText(selling_plan.name)}</option> `
            )
          : ''}
      </select>
    `
  }

  sellingPlanDropdownOptionText(name) {
    if (name.includes('Every 1 Month')) {
      return name + ' (Most popular)'
    }

    return name
  }

  sellingPlanButtons(group) {
    return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan.id}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${e => this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan === selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}"> ${selling_plan.name} </label>
              `
            )
          : ''}
      </fieldset>
    `
  }

  invalidIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D22B2B" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  validIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0BDA51" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  setupMode() {
    return html`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">${this.product ? this.validIcon() : this.invalidIcon()} Product</div>

        <div class="detection">${this.selectedVariant ? this.validIcon() : this.invalidIcon()} Selected Variant</div>

        <div class="detection">${this.form ? this.validIcon() : this.invalidIcon()} Form</div>

        <div class="detection">${this.variantInput ? this.validIcon() : this.invalidIcon()} Variant Input</div>

        <div class="detection">
          ${this.variantChanged ? this.validIcon() : this.invalidIcon()} Variant Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small>If any of these don't pass please troubleshoot using our <a target="_blank" rel="noreferrer" href="https://integrate.skio.com/troubleshooting">troubleshooting guide</a>.</small>
      </div>
    `
  }

  groupContent(group) {
  return html`
    <div
      class="group-content 
        ${this.options?.layout === 'horizontal'
          ? ''
          : this.options?.show_radio_selector && this.options?.dropdownPosition === 'inside'
          ? 'margin-left'
          : ''}"
    >
      <span class="selling-plan-dropdown-label">
        ${this.additionalFrequencyLabel()}
      </span>

      ${this.options?.selector_type === 'dropdown'
        ? this.sellingPlanDropdown(group)
        : ''}

      <!-- TODO: Make the label have the border instead of the group -->
      ${this.options?.selector_type === 'button'
        ? this.sellingPlanButtons(group)
        : ''}

      ${this.additionalContentText()}
    </div>

    ${!this.miniMode
      ? html`
          <div class="group-subtitle">
            ${(() => {
              const futureDiscounts = this.postCheckoutPriceAdjustments(group.selected_selling_plan);
              const futurePercent = futureDiscounts?.[0]?.percent;
              return this.options?.subscription_subtitle && futurePercent
                ? html`
                <div class="group-subtitle-group">
                 <img class="svg-right" src="https://cdn.shopify.com/s/files/1/0310/6373/6457/files/Mask_group_6b17017f-73a3-44d7-9ebc-27f13dba8d23.png?v=1759744359">
                <span>${this.options.subscription_subtitle.replaceAll('[future_price_adjustment]', `${futurePercent}%`)}</span>
                </div>
                <div class="group-subtitle-group">
                 <img class="svg-right" src="https://cdn.shopify.com/s/files/1/0310/6373/6457/files/Mask_group_6b17017f-73a3-44d7-9ebc-27f13dba8d23.png?v=1759744359">
                <span>${this.options?.subscription_subtitle_2}</span>
                </div>
                <div class="group-subtitle-group">
                 <img class="svg-right" src="https://cdn.shopify.com/s/files/1/0310/6373/6457/files/Mask_group_6b17017f-73a3-44d7-9ebc-27f13dba8d23.png?v=1759744359">
                <span>${this.options?.subscription_subtitle_3}</span>
                </div>`
                : '';
            })()}
          </div>
          ${this.freeProductContent('sub')}
        `
      : ''}
  `;
}


  showDetails() {
    return html`
      <details class="skio-details" @mouseover=${e => this.detailsMouseover()} @mouseleave=${e => this.detailsMouseleave()}>
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            How do subscriptions work?
          </span>
        </summary>
        <div class="skio-details--content">
          <ul>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it's not for you</small>
              </div>
            </li>
          </ul>
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

            <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
              Powered by
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black" />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `
  }

  // !SECTION: Element Templates

  render() {
    if (!this.showSubscriptionToggle) {
      return this.debug ? this.setupMode() : ''
    }

    if (!this.viable() || this.options?.layout === 'hidden') {
      return this.debug ? this.setupMode() : ''
    }

    if (this.selectedVariant.selling_plan_allocations.length === 0 && !this.options?.show_without_subscription) {
      return this.debug ? this.setupMode() : ''
    }

    if (this.availableSellingPlanGroups?.length == 0 && !this.options?.show_without_subscription) return
          
    return html`
      ${this.debug ? this.setupMode() : null}
      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-plan-picker-legend">
        <legend id="skio-plan-picker-legend" class="${!this.options?.show_legend ? 'sr-only' : ''}">${unsafeHTML(this.options?.legend_content)}</legend>

        ${nothing}
        ${this.availableSellingPlanGroups?.length
  ? this.availableSellingPlanGroups.flatMap(group =>
   this.getPlansInVariantOrder(group)
  .map(plan => {

        const isSelected = this.selectedSellingPlan?.id === plan.id;
        const discount = this.discount(plan);

        return html`
          <div 
            class="custom-subscription-card ${isSelected ? 'selected' : ''}"
           @click=${() => {
  this.selectSellingPlan(plan.id);

  const oneTimeContainer = this.renderRoot.querySelector('.group-container-onetime');
  const oneTimeInput = this.renderRoot.querySelector(`#one-time-${this.key}`);

  if (oneTimeContainer) {
    oneTimeContainer.classList.remove('group-container--selected');
  }

  if (oneTimeInput) {
    oneTimeInput.checked = false;
  }
}}
          >
            <div class="plan-left">
              ${(() => {
  const content = this.formatPlanContent(plan);

  return html`
    <div class="plan-title">
      <span class="custom-radio ${isSelected ? 'checked' : ''}"></span>
      ${content.title}
      ${discount.percent > 0
        ? html`<span class="plan-badge">SAVE ${discount.percent}%</span>`
        : ''}
    </div>
    ${content.title === 'Monthly Delivery'
  ? html`<div class="freeshipping repeat_subscription">10% off Repeat Subscription Orders.</div>`
  : ''}
    <div class="plan-sub">
      ${content.subtitle}
    </div>
     <div class="freeshipping">Free shipping. Pause or cancel anytime.</div>
     ${this.freeProductContent('sub')}
  `;
})()}

            </div>

            <div class="plan-right">
              <div class="plan-price">
  ${this.getPlanPrice(plan)}
</div>
 </div>
          </div>
        `;
      })
    )

          : ''}
        ${this.options?.show_details == true ? this.showDetails() : ''}
      </fieldset>

      ${this.renderBuyOnceLink()}

      <div class="buy-recommend">
      <img class="icon-tool" src="https://cdn.shopify.com/s/files/1/0310/6373/6457/files/information-circle.svg?v=1771477704">
       We recommend 3-6 months of consistent use for best results.
      </div>

    `
  }

  renderBuyOnceLink() {

  if (!this.selectedVariant) return nothing;

  //const isSubscriptionSelected = !!this.selectedSellingPlan;
  //if (!isSubscriptionSelected) return nothing;


  const variants = this.product?.variants || [];
    if (!variants.length) return nothing;

// get lowest price variant dynamically
const lowestPriceVariant = variants.reduce((lowest, current) => {
  return Number(current.price) < Number(lowest.price)
    ? current
    : lowest;
}, variants[0]);

const oneTimePrice = this.money(lowestPriceVariant.price);

  const { shipping_price_onetime } = this.options || {};

  const shippingPrice = parseFloat(
    String(shipping_price_onetime || 0).replace(/[^\d.]/g, "")
  ) || 0;

  const formattedShipping = `$${shippingPrice.toFixed(2)}`;

  return html`
    <div class="buy-once-wrapper">
    <div
                class="group-container group-container-onetime"
                @click=${this.handleBuyOnceClick}
              >
              <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time purchase"
                  />

                  <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                   <div class="group-all-free-products">
                     <div class="group-topline">

                      ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    ${'' /* <div class="group-title"> One time purchase Buy Once for ${oneTimePrice} + ${formattedShipping} shipping </div> */}

                   <div class="group-title"> One-Time Purchase </div>
                    
                    </div>
                   

                    </div>
                    <div class="skio-price-flex">${oneTimePrice}</div>

                  </div>
                </label>

              
              
               </div>
      
    </div>
  `;
}

  async fetchRules() {
    if (sessionStorage.getItem('skio-discount-rules')) {
      return JSON.parse(sessionStorage.getItem('skio-discount-rules'))
    } else {
      const rules = await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)
        .then(response => response.json())
        .then(response => {
          return response.rules.filter(rule => rule.type !== 'surpriseDelight').sort((a, b) => a.minQuantityToDiscount - b.minQuantityToDiscount)
        })

      sessionStorage.setItem('skio-discount-rules', JSON.stringify(rules))
      return rules
    }
  }

  eligibleItemCount(rule) {
    const eligibleQuantity = rule?.productVariantIds.some(gid => gid.includes(this.selectedVariant.id)) ? this.quantity : 0

    if (!this.cart?.items) return eligibleQuantity

    const cartItems = Number(
      this.cart?.items.reduce(
        (aggregate, item) =>
          rule?.productVariantIds.some(gid => gid.includes(item.id) && item.selling_plan_allocation && gid.includes(this.selectedVariant.id)) ? aggregate + item.quantity : aggregate,
        0
      )
    )

    return cartItems + eligibleQuantity
  }

  getRule() {
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }

    this.rules.forEach((rule, index) => {
      if (rule.code && largestMinQuantity.value < rule.minQuantityToDiscount) {
        if (rule.minQuantityToDiscount <= this.eligibleItemCount(rule)) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })

    this.rule = largestMinQuantity.index > -1 ? this.rules[largestMinQuantity.index] : null
  }

  bindCartEvents() {
    document.addEventListener('CartUpdated', event => {
      this.cart = event.detail
    })
  }

  bindFormEvents() {
    // First try to find form by specified form_id
    this.form = document.querySelector(`#${this.options?.form_id}`)
    
    // If no form found by ID, search through parents and page
    if (!this.form) {
      this.form = this.findProductForm()
    }

    if (!this.form) {
      this.error('No valid product form found')
      return
    }

    // Add debug styling if debug mode is enabled
    if (this.debug) {
      this.form.style.borderStyle = 'solid'
      this.form.style.borderWidth = '4px'
      this.form.style.borderImage = 'repeating-linear-gradient(-55deg,#000,#000 20px,#ffb101 20px,#ffb101 40px)10'
    }

    // Ensure form has an ID
    if (!this.form.getAttribute('id')) {
      this.form.setAttribute('id', `skio-form-${this.product.id}`)
    }

    // Set form attribute on selling plan input
    const sellingPlanInput = this.querySelector('input[name="selling_plan"]')
    if (sellingPlanInput) {
      sellingPlanInput.setAttribute('form', this.form.getAttribute('id'))
    }

    this.variantInput = this.form.querySelector('[name="id"]')
    if (!this.variantInput) this.variantInput = document.querySelector(`[name="id"][form="${this.options?.form_id}"]`)

    if (this.variantInput) {
      this.variantInput.addEventListener('change', e => {
        this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value)
        this.variantChanged = true
      })
    } else {
      this.selectedVariant = this.product.variants[0]
    }

    const $quantityInput = this.form.querySelector('[name="quantity"]')

    if ($quantityInput) {
      this.quantity = Number($quantityInput.value)
      $quantityInput.addEventListener('input', () => {
        this.quantity = Number($quantityInput.value)
      })
    }

    let skio = this
    // Example variantChanged event dispatch:
    // document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
    document.addEventListener('variantChanged', function (e) {
      let variantId = e.detail.variantId
      let variant = skio.product.variants.find(x => x.id == variantId)
      if (variant) skio.selectedVariant = variant
      else skio.log('Unable to find variant with id: ', variantId)
      this.variantChanged = true
      skio.requestUpdate()
    })
  }

  findProductForm() {
    // First try finding form through parent elements
    const formFromParent = this.findFormThroughParents()
    if (formFromParent) return formFromParent

    // If no form found through parents, look for any valid product forms on page
    const allProductForms = this.getAllProductForms()
    return allProductForms[0] || null
  }

  findFormThroughParents() {
    let currentElement = this
    let depth = 0
    const maxDepth = 5

    while (currentElement.parentElement && depth < maxDepth) {
      const forms = Array.from(currentElement.querySelectorAll('form'))
      const validForm = forms.find(form => this.isValidProductForm(form))
      
      if (validForm) return validForm

      currentElement = currentElement.parentElement
      depth++
    }

    return null
  }

  getAllProductForms() {
    return Array.from(document.forms).filter(form => {
      const hasVariantId = this.getVariantId(form)
      return this.isValidProductForm(form) && hasVariantId
    })
  }

  isValidProductForm(form) {
    const hasCartAction = form.getAttribute('action')?.includes('/cart/add')
    const hasSubmitButton = !!form.querySelector('button, [type="submit"]')
    return hasCartAction && hasSubmitButton
  }

  getVariantId(form) {
    // Try getting ID from FormData first
    const formData = new FormData(form)
    const idFromFormData = formData.get('id')
    if (idFromFormData) return Number(idFromFormData)

    // Fallback to finding input element
    const idInput = form.querySelector('[name="id"]')
    return idInput ? Number(idInput.value) : null
  }

  detailsMouseover() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (!details.hasAttribute('open') && this.showDetailsHover == false) {
      summary.click()
      this.showDetailsHover = true
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (details.hasAttribute('open') && this.showDetailsHover == true) {
      summary.click()
      this.showDetailsHover = false
    }
  }

  updated(changed) {
    if (!this.viable()) return

    if (changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group =>
          selling_plan_group.app_id === 'SKIO' && !selling_plan_group.name.toLowerCase().includes('hidden-') && !selling_plan_group.name.toLowerCase().includes('dynamic box subscription')
      )

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = filteredSellingPlanGroups;


      if (this.options?.combine_groups) {
        this.availableSellingPlanGroups = [
          {
            name: this.options?.combined_group_name,
            selling_plans: this.availableSellingPlanGroups.flatMap(group => group.selling_plans),
            id: 'combined_group',
            app_id: 'SKIO',
          },
        ]
      }

      // TODO: Select proper group depending on what selling plan is selected

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length) {
        const url = new URL(window.location.href)
        const urlSelectedSellingPlanId = url.searchParams.get('selling_plan')

        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach(group => {
         const availableSellingPlans = this.getAvailableSellingPlans(group);
          const urlSelectedSellingPlan = availableSellingPlans.find(plan => plan.id == urlSelectedSellingPlanId)
          const nameSelectedSellingPlan = availableSellingPlans.find(plan => plan.name === this.selectedSellingPlan?.name)
          const defaultSellingPlan =
            this.options?.default_subscription && this.options.default_subscription.trim() !== ''
              ? availableSellingPlans.find(plan => plan.name.toLowerCase().includes(this.options.default_subscription.toLowerCase()))
              : null

          group.selected_selling_plan = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan || this.getFirstPlanForVariant(group)

          const isAnyPlanSelected = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan

          group.selected = !!isAnyPlanSelected
        })

        if (
          this.shouldSelectSubscriptionByDefault(urlSelectedSellingPlanId)
        ) {
          let selectedSellingPlanGroup = this.availableSellingPlanGroups.find(group => group.selected) || this.availableSellingPlanGroups[0]
          let selectedSellingPlanId = selectedSellingPlanGroup.selected_selling_plan.id
          this.selectSellingPlan(selectedSellingPlanId)
        } else {
          this.selectSellingPlanGroup(null)
        }
      } else {
        this.selectSellingPlanGroup(null)
      }
    }

    if (changed.has('selectedSellingPlan')) {
      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          variant: this.selectedVariant,
          productId: this.product.id,
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
        },
      })

      this.dispatchEvent(event)

      this.dispatchEvent(
        new CustomEvent('change', {
          detail: { value: this.selectedSellingPlan?.id },
        })
      )
    }

    this.updateForm()
    this.updateExternalPrice()

    if (!this.disableUrl) {
      this.updateURLParams()
    }

    if (changed.has('quantity')) {
      this.getRule()
    }

    if (changed.has('cart')) {
      this.getRule()
    }

    this.updateExternalElements()

    // 🔥 Safely update Add to Cart after render cycle
if (this.form) {
  this.updateAddToCartButton(this.form, !!this.selectedSellingPlanGroup);
}

  }

  updateExternalElements() {
    document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(el => {
      el.innerHTML = this.price(this.selectedSellingPlan)
    })

    document.querySelectorAll(`[skio-subscription-content]`).forEach(el => {
      el.style.display = this.selectedSellingPlan ? 'block' : 'none'
    })
  }

  // SECTION: Utility Functions
  log(...args) {
    args.unshift(`%c[skio plan picker][${this.key}]`, 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error(...args) {
    args.unshift(`%c [skio plan picker][${this.key}]`, 'color: #ff0000')
    console.error.apply(console, args)
  }

  appendOrdinalSuffix(num) {
    const j = num % 10,
      k = num % 100
    if (j == 1 && k != 11) {
      return num + 'st'
    }
    if (j == 2 && k != 12) {
      return num + 'nd'
    }
    if (j == 3 && k != 13) {
      return num + 'rd'
    }
    return num + 'th'
  }

  viable() {
    const errors = []

    const sellingPlanInput = this.querySelector('input[name=selling_plan]')
    if (!sellingPlanInput) {
      errors.push('Missing selling plan input')
    }

    if (!this.product) {
      errors.push('No product found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    // if (!this.selectedVariant) {
    //   errors.push('No variant found. Please pass a product or productHandle to the skio-plan-picker component.')
    // }
    if (!this.form) {
      errors.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".')
    }
    // if (!this.variantInput) {
    //   errors.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"')
    // }

    if (errors.length == 0) return true

    this.error('Errors', errors)
    return false
  }


  getAvailableSellingPlans(group) {
  // 🔥 return ALL plans inside group (no variant filtering)
  return group?.selling_plans || [];
}


  // !SECTION: Utility Functions

  // Update selected selling plan group; called on click of group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    const selectedLabel = group?.name ? 'subscribe' : 'one time';
    this.dispatchEvent(new CustomEvent('skioPlanChange', {
      bubbles: true,
      composed: true,
      detail: { selected: selectedLabel }
    }));

    const form = this.closest('form');

    if (form) {
      this.updateAddToCartButton(form, group ? true : false);
    }

    if (!this.collectionMode) {
      if (form) this.updateFormCardPrice(form, this.selectedSellingPlan);
    }
  }

 

selectSellingPlan(selling_plan_id) {

  console.log("Clicked selling_plan_id:", selling_plan_id);

  // ✅ Preserve current selected variant first
  let matchingVariant = this.selectedVariant;

  // Check if current variant supports this selling plan
  const currentVariantHasPlan =
    matchingVariant?.selling_plan_allocations?.some(
      allocation =>
        String(allocation.selling_plan_id) === String(selling_plan_id)
    );

  // ❌ Only fallback if current variant invalid
  if (!currentVariantHasPlan) {

    matchingVariant = null;


// detect any non-quantity option
const hasExtraVariantOption = this.product.options.some(
  option => option.toLowerCase() !== 'quantity'
);

const currentFlavor = this.selectedVariant?.option1;

// find matching variant
for (const variant of this.product.variants) {

  // ✅ only preserve flavor if flavor exists
  
  const sameFlavor =
  !hasExtraVariantOption ||
  variant.option1 === currentFlavor;

  if (!sameFlavor) continue;

  for (const allocation of variant.selling_plan_allocations || []) {

    if (
      String(allocation.selling_plan_id) ===
      String(selling_plan_id)
    ) {

      matchingVariant = variant;
      break;
    }
  }

  if (matchingVariant) break;
}

  }

  if (!matchingVariant) {
    console.warn("❌ No matching variant found");
    return;
  }

  console.log("Switching to variant:", matchingVariant.id);

  this.selectedVariant = matchingVariant;

  // 🔥 Dawn-safe variant switch
  const variantRadios = document.querySelector('variant-radios');
  const variantSelects = document.querySelector('variant-selects');

  if (variantRadios) {

    matchingVariant.options.forEach((optionValue) => {

      const radio = variantRadios.querySelector(
        `input[type="radio"][value="${optionValue}"]`
      );

      if (radio) {
        radio.checked = true;

        radio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });

  } else if (variantSelects) {

    matchingVariant.options.forEach((optionValue, index) => {

      const select = variantSelects.querySelectorAll('select')[index];

      if (select) {
        select.value = optionValue;

        select.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });
  }

  // Continue Skio selection
  const selectedGroup = this.availableSellingPlanGroups.find(group =>
    group.selling_plans.some(
      plan => plan.id == selling_plan_id
    )
  );

  if (selectedGroup) {

    const selectedSellingPlan =
      selectedGroup.selling_plans.find(
        plan => plan.id == selling_plan_id
      );

    selectedGroup.selected_selling_plan =
      selectedSellingPlan;

    this.selectedSellingPlanGroup =
      selectedGroup;

    this.selectedSellingPlan =
      selectedSellingPlan;
  }

  this.requestUpdate();
}


handleBuyOnceClick = (e) => {

  e.preventDefault();
  e.stopPropagation();

  if (!this.product?.variants?.length) return;

  const form = this.form || this.closest('form');
  if (!form) return;

  const formId = form.getAttribute('id');

  // =========================
  // ✅ DYNAMIC FLAVOR DETECTION
  // =========================

  const hasFlavorOption = this.product.options.some(
    option => option.toLowerCase() === 'flavor'
  );

  let matchingVariants = [];

  // ✅ Products WITH flavor
  if (hasFlavorOption) {

    const currentFlavor = this.selectedVariant?.option1;

    matchingVariants = this.product.variants.filter(
      variant =>
        variant.option1 === currentFlavor &&
        variant.available
    );

  } else {

    // ✅ Products WITHOUT flavor
    matchingVariants = this.product.variants.filter(
      variant => variant.available
    );
  }

  if (!matchingVariants.length) return;

  // =========================
  // ✅ LOWEST PRICE VARIANT
  // =========================

  const lowestPriceVariant = matchingVariants.reduce(
    (lowest, current) => {

      return Number(current.price) < Number(lowest.price)
        ? current
        : lowest;

    },
    matchingVariants[0]
  );

  // =========================
  // 🔥 GET INPUTS
  // =========================

  const variantInput =
    form.querySelector('input[name="id"]');

  const sellingPlanInput =
    document.querySelector(
      `input[name="selling_plan"][form="${formId}"]`
    );

  if (!variantInput) return;

  // =========================
  // ✅ UI HANDLE
  // =========================

  const allContainers =
    this.renderRoot.querySelectorAll('.group-container');

  allContainers.forEach(el =>
    el.classList.remove('group-container--selected')
  );

  const allInputs =
    this.renderRoot.querySelectorAll('.group-input');

  allInputs.forEach(inp => inp.checked = false);

  const container = e.currentTarget;
  const input = container.querySelector('input');

  container.classList.add('group-container--selected');

  if (input) input.checked = true;

  // =========================
  // ✅ REMOVE SUBSCRIPTION
  // =========================

  this.selectedSellingPlan = null;
  this.selectedSellingPlanGroup = null;

  if (sellingPlanInput) {
    sellingPlanInput.value = '';
  }

  // =========================
  // ✅ ACTUAL VARIANT SWITCH
  // =========================

  this.selectedVariant = lowestPriceVariant;

  variantInput.value = lowestPriceVariant.id;

  variantInput.dispatchEvent(
    new Event('change', { bubbles: true })
  );

  // =========================
  // ✅ SYNC DAWN RADIOS
  // =========================

  const variantRadios =
    document.querySelector('variant-radios');

  const variantSelects =
    document.querySelector('variant-selects');

  if (variantRadios) {

    lowestPriceVariant.options.forEach(optionValue => {

      const radio = variantRadios.querySelector(
        `input[type="radio"][value="${optionValue}"]`
      );

      if (radio) {

        radio.checked = true;

        radio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });

  } else if (variantSelects) {

    lowestPriceVariant.options.forEach(
      (optionValue, index) => {

        const select =
          variantSelects.querySelectorAll('select')[index];

        if (select) {

          select.value = optionValue;

          select.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      }
    );
  }

  this.requestUpdate();
};




  updateExternalPrice() {
    document.querySelectorAll(this.options?.external_price_selector).forEach(el => {
      this.selectedSellingPlan ? (el.innerHTML = this.price(this.selectedSellingPlan)) : (el.innerHTML = this.money(this.selectedVariant.price))
    })
  }

  additionalFrequencyLabel() {
    if (!this.options?.additional_frequency_label || this.options?.additional_frequency_label == '') return

    return unsafeHTML(this.options?.additional_frequency_label)
  }

  additionalContentText() {
    if (!this.options?.additional_subscription_content || this.options?.additional_subscription_content == '') return

    return html`
      <div class="group-content-additional">
        ${unsafeHTML(
          this.options?.additional_subscription_content
            .replaceAll(
              '[discount]',
              this.options?.discount_format === 'absolute' ? this.money(this.discount(this.selectedSellingPlan).absolute) : this.discount(this.selectedSellingPlan).percent + '%'
            )
            .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(this.selectedSellingPlan) || '')
        )}
      </div>
    `
  }

  // SECTION: Discount Functions
  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discountText(selling_plan) {
    const discount = this.discount(selling_plan)
    const hasInvalidDiscount = Object.values(discount).some(value => value === 0 || value === Infinity || value.toString().includes('-'))

    if (hasInvalidDiscount) {
      return '' // Return empty if any invalid condition is met
    } else {
      return unsafeHTML(
        this.options?.discount_text
          .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
          .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(selling_plan) || '')
      )
    }
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: 0, amount: 0 }
    return this.getDiscountFromPriceAdjustment(selling_plan, selling_plan.price_adjustments[0])
  }

  postCheckoutPriceAdjustments(selling_plan) {
    const { price_adjustments } = selling_plan
    const postCheckoutPriceAdjustments = price_adjustments.filter(({ position }) => position !== 1)
    const discounts = postCheckoutPriceAdjustments.map(price_adjustment => this.getDiscountFromPriceAdjustment(selling_plan, price_adjustment))
    return discounts
  }

  postCheckoutDiscountsText(sellingPlan = this.selectedSellingPlan) {
    if (!sellingPlan || !this.options?.future_price_adjustments_text || this.future_price_adjustments_text == '') return

    const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(sellingPlan)
    if (!postCheckoutPriceAdjustments.length) return

    return postCheckoutPriceAdjustments.map((discount, index) =>
      this.options?.future_price_adjustments_text
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
        .replaceAll('[order_count]', index + 1)
        .replaceAll('[order_count_ordinal]', this.appendOrdinalSuffix(index + 1))
    )
  }

  getDiscountFromPriceAdjustment(selling_plan, price_adjustment) {
    const discount = {
      percent: 0,
      amount: 0,
      absolute: 0,
    }

    let multiplier = 1

    let sellingPlanGroup = this.product.selling_plan_groups.find(group => group.selling_plans.some(plan => plan.id == selling_plan.id))

    if (sellingPlanGroup?.name === 'Prepaid') {
      const str = selling_plan.name // replace with your string
      const intervalDate = /\b\d+\s*(days|weeks|months|years)\b/gi
      const intervalDateMatches = str.match(intervalDate)

      if (intervalDateMatches?.length) {
        const intervals = intervalDateMatches[0].match(/\d+/g)
        multiplier = intervals[0] / (intervals[1] || 1)
        multiplier = multiplier > 1 ? multiplier : 1
      }
    }

    const price = this.selectedVariant.price
    const compareAtPrice = this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > price ? this.selectedVariant.compare_at_price : price

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = price_adjustment.value
        discount.absolute = Math.round((price * price_adjustment.value) / 100.0)
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = Math.round(((price_adjustment.value * 1.0) / price) * 100.0)
        discount.absolute = price_adjustment.value
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = Math.round((((compareAtPrice * multiplier - price_adjustment.value) * 1.0) / (compareAtPrice * multiplier)) * 100.0)
        discount.absolute = compareAtPrice * multiplier - price_adjustment.value
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }

  /**
   * Formats a number of cents into a currency string using Shopify format string.
   *
   * https://help.shopify.com/en/manual/international/pricing/currency-formatting#currency-formatting-options
   *
   * Originally from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
   *
   * @param cents - The number of cents to format.
   * @param formatString - The format string to use.
   * @returns The formatted currency string.
   */
  money(cents, formatString = this.moneyFormat) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/

    /**
     * Formats a number of cents into a currency string using the provided
     * precision, thousands separator, and decimal separator.
     * @param number - The number of cents to format.
     * @param precision - The number of decimal places to include.
     * @param thousands - The character to use as the thousands separator.
     * @param decimal - The character to use as the decimal separator.
     * @returns The formatted currency string.
     */
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return '0'
      }

      const numString = (number / 100.0).toFixed(precision)
      const parts = numString.split('.')
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      const cents = parts[1] ? decimal + parts[1] : ''
      return dollars + cents
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
      switch (placeholder) {
        case 'amount':
          // Ex.	1,134.65
          return formatWithDelimiters(cents, 2)
        case 'amount_no_decimals':
          // Ex. 1,135
          return formatWithDelimiters(cents, 0)
        case 'amount_with_comma_separator':
          // Ex. 1.134,65
          return formatWithDelimiters(cents, 2, '.', ',')
        case 'amount_no_decimals_with_comma_separator':
          // Ex. 1.135
          return formatWithDelimiters(cents, 0, '.', ',')
        case 'amount_with_apostrophe_separator':
          // Ex. 1'134.65
          return formatWithDelimiters(cents, 2, "'", '.')
        case 'amount_no_decimals_with_space_separator':
          // Ex. 1 135
          return formatWithDelimiters(cents, 0, ' ')
        case 'amount_with_space_separator':
          // 1 134,65
          return formatWithDelimiters(cents, 2, ' ', ',')
        case 'amount_with_period_and_space_separator':
          // 1 134.65
          return formatWithDelimiters(cents, 2, ' ', '.')
        default:
          return match
      }
    })
  }

  // !SECTION: Discount Functions
  price(selling_plan, formatted = true) {
    if (this.rule) {
      return formatted
        ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100))
        : this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100)
    }

    return formatted ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount) : this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    const formId = this.options?.form_id || `product-form-${this.product?.id}`;
    const $sellingPlans = document.querySelectorAll(
      `input[name="selling_plan"][form="${formId}"], #${formId} input[name="selling_plan"]`
    );
  
    $sellingPlans.forEach(($sellingPlan) => {
      $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';
      $sellingPlan.dispatchEvent(new Event('change'));
    });
    }

  // SECTION: Additional Functionality
  updateURLParams() {
    const url = new URL(window.location.href)

    if (this.selectedSellingPlan) {
      url.searchParams.set('selling_plan', this.selectedSellingPlan.id)
      window.history.replaceState({}, '', url.href)
    } else {
      url.searchParams.delete('selling_plan')
      window.history.replaceState({}, '', url.href)
    }
  }

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then(response => response.json())
      .then(response => {
        this.log('Added item to cart: ', response)
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        })

        this.dispatchEvent(event)
      })
      .catch(error => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = handle => {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }
  // !SECTION: Additional Functionality

  getGroupTitle(group) {
    if (group.name !== 'Prepaid' && this.options?.subscription_title) {
      return this.options.subscription_title;
    }
    
    if (group.name === 'Prepaid' && this.options?.prepaid_title) {
      return this.options.prepaid_title;
    }
    
    return group.name;
  }

  /**
   * Renders the discount text for a group, if applicable.
   */
 renderDiscountText(group) {
  const text = this.getDiscountTextContent(group);
  const subscription_price_discount_price = this.options?.subscription_price_discount_price;

  if (!text) return nothing;

  // If subscription discount value is present → use it with the discount_text template format
  // This ensures it matches the format used by getDiscountTextContent ("Save [discount]")
  const finalText = subscription_price_discount_price
    ? (this.options?.discount_text || 'Save [discount]').replace('[discount]', `${subscription_price_discount_price}%`)
    : text;

  return html`
    <span class="savings ${this.options?.discount_style}">
      ${finalText}
    </span>
  `;
}


  renderGroupTooltip(group) {
    const tooltip = this.getTooltipText(group); // string | ''
    return tooltip
      ? html`<div class="group-title-sub-tooltip" data-tooltip=${tooltip}></div>`
      : nothing;
  }

  getTooltipText(group) {
    const plan = group?.selected_selling_plan;
    if (!plan) return '';
  
    const raw = this.discount(plan);
    const invalid = !raw || Object.values(raw).some(v =>
      v === 0 || v === Infinity || String(v).includes('-')
    );
    if (invalid) return '';
  
    const discountValue = this.options?.discount_format === 'absolute'
      ? this.money(raw.absolute)
      : `${raw.percent}%`;
  
    const adj = this.postCheckoutPriceAdjustments(plan);
    const recurringPercent = Array.isArray(adj) ? adj[0]?.percent : null;

    let text; 
    if (typeof recurringPercent === 'number' && recurringPercent > 0) {
      text = `Save ${discountValue} on your first order, then ${recurringPercent}% off and `;
    } else {
      text = `${discountValue} off and `;
    }

    return text + 'FREE shipping on all US subscription orders. Change or cancel anytime.';
  }

  getDiscountTextContent(group) {
    if (!group || !group.selected_selling_plan) return '';
    
    const rawDiscount = this.discount(group.selected_selling_plan);
    const invalid = Object.values(rawDiscount).some(v => v === 0 || v === Infinity || v.toString().includes('-'));
    if (invalid) return '';
  
    const discountValue =
      this.options?.discount_format === 'absolute'
        ? this.money(rawDiscount.absolute)
        : rawDiscount.percent + '%';

    // mini mode -> return text, not a template
    if (this.miniMode) return this.miniText(discountValue) || `$${discountValue}`;

    const pca = this.postCheckoutPriceAdjustments(group?.selected_selling_plan) || [];
    let template = this.options?.discount_text || '';

    if (!pca.length) {
      const [head, tail] = template.split('[discount]');
      template = tail !== undefined ? `${head}[discount]` : template;
    }
    const formattedText =
      template
        ?.replaceAll('[discount]', discountValue)
        .replaceAll('[future_price_adjustments]',
          this.postCheckoutDiscountsText(group.selected_selling_plan) || ''
        ) || '';

    return formattedText;  
  }
  
  miniText(discount) {
    return this.options?.mini_mode_discount_text.replace('[discount]', discount);
  }

  renderPrice(selectedVariant, options = {}, selectedSellingPlan = null) {
  if (this.miniMode) return nothing;

  const originalPrice = selectedVariant?.price;
  let variantPrice = selectedVariant?.price;

  // One-time discount (when NOT on subscription)
  if (!selectedSellingPlan && this.options?.one_time_discount_price) {
    variantPrice = (1 - this.options.one_time_discount_price / 100) * variantPrice;
  }

  const compareAt = selectedVariant?.compare_at_price;
  const hasSellingPlan = !!selectedSellingPlan;

  const subscription_price_discount_price = this.options?.subscription_price_discount_price;

  let sellingPlanPrice;

  if (hasSellingPlan) {
    // Base selling plan price
    let basePlanPrice = this.price(selectedSellingPlan, false);

    // If subscription discount exists → apply it
    if (subscription_price_discount_price) {
      const discountedPlanPrice =
        (1 - subscription_price_discount_price / 100) * variantPrice;

      sellingPlanPrice = this.money(discountedPlanPrice);
    } else {
      // No subscription discount → original plan price
      sellingPlanPrice = this.price(selectedSellingPlan);
    }
  } else {
    // No selling plan → one-time price (already adjusted above)
    sellingPlanPrice = this.money(variantPrice);
  }

  const hasOneTimeDiscount = !hasSellingPlan && !!this.options?.one_time_discount_price;

  const comparePriceCondition =
    options.show_compare_price &&
    (
      (compareAt > variantPrice) ||
      (hasSellingPlan && variantPrice > this.price(selectedSellingPlan, false)) ||
      hasOneTimeDiscount
    );

  return html`
    <div class="skio-price" aria-live="polite">
      <div class="skio-price-flex">
        ${sellingPlanPrice}
        ${comparePriceCondition
          ? html`<s aria-hidden="true">${this.money(compareAt || originalPrice)}</s>`
          : ''}
      </div>
    </div>
  `;
}


  shouldSelectSubscriptionByDefault(urlSelectedSellingPlanId) {
    const onCollectionWithToggleOff =
      this.collectionMode && this.showSubscriptionToggle === false;

    return (
      !onCollectionWithToggleOff && (
        (!this.variantChanged && this.options?.start_onetime === false) ||
        this.product.requires_selling_plan === true ||
        urlSelectedSellingPlanId ||
        this.selectedSellingPlan
      )
    );
  }

  disconnectedCallback() {
    window.removeEventListener('skio-subscription-toggle', this.handleSubscriptionToggle);
    super.disconnectedCallback();
  }

  handleSubscriptionToggle = (e) => {
    this.showSubscriptionToggle = e.detail?.show_subscriptions ?? false;
    if (this.showSubscriptionToggle) {
      const group = this.selectedSellingPlanGroup || this.availableSellingPlanGroups?.[0];
      group ? this.selectSellingPlanGroup(group) : this.selectSellingPlanGroup(null);
    } else {
      this.selectSellingPlanGroup(null);
    }
    this.requestUpdate();
    // update innter text and custom attributes
    this.updateSubscriptionUI();
  }

  updateSubscriptionUI() {
    if (!this.collectionMode) return;

    const isChecked = this.showSubscriptionToggle;
    const dataSubscriptionEl = document.querySelector('.data-subscription-value');
    if (dataSubscriptionEl) {
      dataSubscriptionEl.setAttribute('data-subscription', isChecked.toString());
    }
  
    const parentForm = this.closest('form');
    if (parentForm) {
      this.updateAddToCartButton(parentForm, isChecked);
    }  
  }

  updateAddToCartButton(form, isChecked) {
  if (!form) return;

  const button =
    form.querySelector('button[type="submit"]') ||
    form.querySelector('.product-form__submit') ||
    form.querySelector('.product-form__cart-submit');

  if (!button) return;

  // 🔥 ALWAYS enable button if variant is available
  if (this.selectedVariant?.available) {
    button.disabled = false;
  }

  // Optional: change text only
  const spanText = button.querySelector('span');
  if (spanText) {
    spanText.textContent = isChecked ? 'Add to Cart' : 'Add to Cart';
  }
}


  updateFormCardPrice(form, selectedSellingPlan) {
    const prices = form.querySelectorAll('.product-price__price');
    const percent = form.getAttribute('subcription') === '5%' ? 5 : 10;
    const isSubscribe = !!selectedSellingPlan;

    prices.forEach((el) => {
      const subscribeVal = el.getAttribute('data-suscribe-time');
      const oneTimeVal = el.getAttribute('data-one-time');
      const base = parseFloat(el.innerText.replace(/[^0-9.]/g, ''));
  
      if (isSubscribe) {
        const discount = (base / 100) * percent;
        const discountedPrice = (base - discount).toFixed(2);
        el.innerHTML = subscribeVal || `$${discountedPrice}`;
        el.style.color = '#bd472a';
      } else {
        el.innerHTML = oneTimeVal || `$${base.toFixed(2)}`;
        el.style.color = '#1f0a00';
      }
    });
  }

  freeProductContent(type) {
  if (!this.pdpMode) return nothing;

  const { 
    free_product_text, 
    free_product_image, 
    free_product_text_for_onetime 
  } = this.options || {};

  // Select correct text depending on type
  const freeText = type === 'sub' ? free_product_text : free_product_text_for_onetime;

  // Return nothing if text or image missing
  if (!freeText || !free_product_image) return nothing;

  return html`
    <div class="free_first_time">
      <div class="frother-image-text">
        <img width="50" height="50" src="${free_product_image}" alt="Free product">
        <div class="line_text">${unsafeHTML(freeText)}</div>
      </div>
    </div>
  `;
}


  renderTooltipText(group) {
    let tooltipText = '';
    // if there's a first time discount
    const rawDiscount = this.discount(group.selected_selling_plan);
    const hasInvalidDiscount = Object.values(rawDiscount).some(value => value === 0 || value === Infinity || value.toString().includes('-'));
    if (hasInvalidDiscount) return nothing;
    
    const discountValue =
      this.options?.discount_format === 'absolute'
        ? this.money(rawDiscount.absolute)
        : rawDiscount.percent + '%';
    tooltipText += 'Save ' + discountValue + ' on your first order';
    // if there's a recurring discount
    const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(group.selected_selling_plan);
    if (postCheckoutPriceAdjustments?.length) {
      const recurringPercent = postCheckoutPriceAdjustments[0]?.percent;
      if (typeof recurringPercent === 'number' && recurringPercent > 0) {
        tooltipText += `, then ${recurringPercent}% off`;
      }
    }
    // tack on the free shipping text
    tooltipText += ' and get FREE shipping on all US subscription orders. Change or cancel anytime.';
    return tooltipText;
  }
  getSortedPlans(plans) {
  return plans
    .slice()
    .sort((a, b) => {
      const getMonths = (plan) => {
        if (plan?.billing_policy?.interval_count) {
          return plan.billing_policy.interval_count;
        }

        if (plan?.name) {
          const match = plan.name.match(/(\d+)\s*m/i);
          if (match) return parseInt(match[1], 10);
        }

        return 0;
      };

      return getMonths(b) - getMonths(a); // 6 → 3 → 1
    });
}
}



if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPicker)
}

if (window) window.SkioPlanPicker = SkioPlanPicker
